import _defineProperty from "@babel/runtime/helpers/defineProperty";
/**
 * BmSidebar handles the state and interactions of the Business Manager's sidebar,
 * specifically managing its open and close actions based on the position of the minimize button.
 *
 * @class BmSidebar
 *
 * @property closedBmMenuXPosition - The X position of the sidebar when it is minimized (default: 60).
 * @property minimizeButton - The HTML button element used to minimize or maximize the sidebar.
 *
 * @method get isOpen - Returns `true` if the sidebar is open, based on the X position of the minimize button.
 * @method open - Opens the sidebar if it is currently closed by triggering a click on the minimize button.
 * @method close - Closes the sidebar if it is currently open by triggering a click on the minimize button.
 */
export class BmSidebar {
  constructor() {
    // when sidebar minimized minimizeButton x should be 54.
    _defineProperty(this, "closedBmMenuXPosition", 60);
    _defineProperty(this, "minimizeButton", void 0);
    // Business Manager renders it as either `minimize-button` or
    // `actions-bar-minimize-button`, and on the newer ToggleButton the hook
    // lands on the Tooltip wrapper — a programmatic click there never reaches
    // the button — so take the inner <button> when the match is not one.
    const host = document.querySelector(`[data-hook$="minimize-button"]`);
    this.minimizeButton = host instanceof HTMLButtonElement ? host : host == null ? void 0 : host.querySelector('button');
  }
  get isOpen() {
    var _this$minimizeButton;
    return ((_this$minimizeButton = this.minimizeButton) == null || _this$minimizeButton.getBoundingClientRect == null || (_this$minimizeButton = _this$minimizeButton.getBoundingClientRect()) == null ? void 0 : _this$minimizeButton.x) > this.closedBmMenuXPosition;
  }
  open() {
    if (!this.isOpen) {
      requestAnimationFrame(() => {
        var _this$minimizeButton2;
        return (_this$minimizeButton2 = this.minimizeButton) == null ? void 0 : _this$minimizeButton2.click();
      });
    }
  }
  close() {
    if (this.isOpen) {
      var _this$minimizeButton3;
      (_this$minimizeButton3 = this.minimizeButton) == null || _this$minimizeButton3.click();
    }
  }
}
//# sourceMappingURL=bm-sidebar.js.map